import { isPresent } from '@ember/utils';

export default function isNull(checked) {
  return !isPresent(checked);
}
